module.exports = __webpack_public_path__ + "static/media/guru-nanak-dev-ji-flower-1.8d97b9f4.gif";